/**
 * Chapters are the spine of the navigation. The entry page, the menu
 * overlay and the page-transition curtain all read from this one list,
 * so the rhythm stays identical everywhere.
 */
export const CONTACT_EMAIL = "hello@digitalbillionsgroup.com";
export const APS_URL = "https://advanced.digitalbillionsgroup.com";

export const CHAPTERS = [
  {
    id: "studio", num: "01", label: "Digital Billions Group", short: "Studio",
    to: "/home", image: "tileStudio", cta: "Enter the studio",
    blurb: "Who we are, how we work, and why we build with people.",
  },
  {
    id: "products", num: "02", label: "Products", short: "Products",
    to: "/products", image: "tileProducts", cta: "Browse products",
    blurb: "Subscription development and automation. Pick a place to start.",
  },
  {
    id: "aps", num: "03", label: "Advanced Platform Services", short: "APS",
    href: APS_URL, external: true, image: "tileAps", cta: "Visit APS",
    blurb: "HIPAA-conscious, SOC 2-aligned, enterprise-grade platforms.",
  },
  {
    id: "vending", num: "04", label: "VendBabee", short: "VendBabee",
    href: "https://vendbabee.com", external: true, image: "tileVending", cta: "Visit VendBabee",
    blurb: "Smart, cashless vending that keeps communities stocked 24/7.",
  },
];

export const chapterForPath = (pathname) => {
  if (pathname.startsWith("/products")) return CHAPTERS[1];
  if (pathname.startsWith("/home")) return CHAPTERS[0];
  return null;
};
